<ul *ngIf="hoofdAntwoorden" class="ols-checkbox-group">
  <li class="ols-checkbox" *ngFor='let hoofdAntwoord of hoofdAntwoorden'
    [ngClass]="{'selected': isAntwoordSelected(hoofdAntwoord)}">
    <div class="main-question-container" [id]="geefMeetid(vraag.titel, hoofdAntwoord.titel)"
      (click)='checkboxClicked(hoofdAntwoord)'>
      <div class='ols-box'>
        <div class='outer'></div>
      </div>
      <div class='text'>
        <div class='text-header'>{{hoofdAntwoord.titel}}</div>
        <div *ngFor='let regel of hoofdAntwoord.antwoordregels' class='text-sub'>{{regel}}</div>
      </div>
    </div>
    <div *ngIf='isAntwoordSelected(hoofdAntwoord) && getSubAntwoordenLength(hoofdAntwoord) > 0'
      class='sub-questions-container' [ngClass]="{groupSubQuestion: getSubAntwoordenLength(hoofdAntwoord) > 1}">
      <div class='sub-question' *ngFor='let subAntwoord of getSubAntwoorden(hoofdAntwoord)'>
        <div class='text'>
          <div class='text-header'>{{subAntwoord.titel}}</div>
          <div *ngFor='let regel of subAntwoord.antwoordregels' class='text-sub'>{{regel}}</div>
        </div>
        <ng-container [ngSwitch]="subAntwoord.sub_control_type">
          <app-slider *ngSwitchCase='doorvraagType.Slider' [minText]="getSliderParameters(subAntwoord).minText"
            [maxText]="getSliderParameters(subAntwoord).maxText" [min]='getSliderParameters(subAntwoord).min' [max]='getSliderParameters(subAntwoord).max'
            [minSelectable]='getSliderParameters(subAntwoord).minSelectable' [step]='getSliderParameters(subAntwoord).step'
            [value]='getSliderValue(subAntwoord)' (valueChange)='sliderValueChanged(subAntwoord, $event)'>
          </app-slider>
          <app-multiline-text *ngSwitchCase='doorvraagType.TextArea'
            [maxlength]="getValidatieParameter(subAntwoord, 'MAX_LENGTE', '500')" rows="3"
            [placeholder]='subAntwoord.standaard_waarde_tekst' (valueChange)='textAreaValueChanged(subAntwoord, $event)'
            [value]="getTextAreaValue(subAntwoord)" alwaysShowBorder='true'></app-multiline-text>
        </ng-container>
      </div>
    </div>
  </li>
</ul>

<p class="error-block" *ngIf="submitClicked && minChoices > selectedAntwoordIds.length && minChoices === 1">Maak alsjeblieft een keuze</p>
<p class="error-block" *ngIf="submitClicked && minChoices > selectedAntwoordIds.length && minChoices > 1">Maak minimaal {{minChoices}} keuzes</p>
